document.querySelectorAll('.professionals-carousel__slider.swiper').forEach(container => {
  new Swiper(container, {
    loop: false,
    slidesPerView: 1.1,
    slidesPerGroup: 1,
    simulateTouch: true,
    spaceBetween: 20,
    watchOverflow: false,
    breakpoints: {
      768: {
        slidesPerView: 1.15,
      },
      1250: {
        spaceBetween: 52,
      },
      1599: {
        slidesPerView: 2.15,
      },
    },
    pagination: {
      el: document.querySelector('.professionals-carousel .swiper-pagination'),
      clickable: true,
    },
    navigation: {
      nextEl: document.querySelector('.professionals-carousel .swiper-button-next'),
      prevEl: document.querySelector('.professionals-carousel .swiper-button-prev'),
    }
  });
});